<template>
    <TitleComponent v-if="isMobile == true" :title="t('setup10')"></TitleComponent>
    <div class="internal">
        <div class="demo-collapse">
            <div class="el-collapse" v-for="(item, i) in messageList" @click="setRead(item.id, item.is_read, i)" :key="i">
                <div class="title">
                    <div>
                        <div style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">
                            {{ item.title }}
                        </div>

                        <svg-icon v-if="item.is_read == 1" icon-class="Unread" />
                    </div>
                    <div class="svg-icon" :class="i == selIndex ? 'sel-icon' : ''"><svg-icon icon-class="you" /></div>

                </div>
                <div class="message" v-show="i == selIndex">{{ item.message }}</div>
            </div>
        </div>
    </div>
</template>
<script setup>
import TitleComponent from "@/components/TitleComponent/index.vue"
import { getMessageListAPI, setReadAPI } from '@/apis/user'
import { useI18n } from 'vue-i18n'
const { t,  } = useI18n();
const isMobile = ref(false);//代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getMessage()
})

const messageList = ref()
const unread = ref()
const selIndex = ref(-1)
const getMessage = async () => {
    const res = await getMessageListAPI({is_read:null })
            if (res.code == 0) {
                messageList.value=res.data.list
                unread.value=res.data.unread
            } else {
                ElMessage({ type: 'error', message: res.message })
            }
}
const setRead = async (id, type, index) => {
    if (index == selIndex.value) {
        selIndex.value = -1
    } else {
        selIndex.value = index
    }
    if (type == 1) {
        const res = await setReadAPI({ message_id: id })
        if (res.code == 0) {
            console.log('成功')
            getMessage()
        }
    }

}
</script>
<style scoped lang="scss">
.internal {
    padding-top: 33px;
    background-color: #fff;

    .demo-collapse {
        padding: 10px 0 0 0;

        .el-collapse {
            padding: 0 20px;
            border: none;
            border-bottom: 1px solid #F3F6F8;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #222222;
            line-height: 20px;
            text-align: left;
            font-style: normal;

            .title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 48px;
                >div {
                    display: flex;
                    align-items: center;
                }

                .svg-icon {
                    width: 21px;
                    height: 21px;
                    border-radius: 50%;
                    background-color: #F8F8F8;
                    justify-content: center;
                    transform: rotate(0deg);
                    transition:all .5s;
                }

                .sel-icon {
                    transform: rotate(90deg);
                    transition:all .5s;
                }
            }

            .message {
                padding-bottom: 13px;
            }
        }
    }


}
</style>